import { initActiveEntranceName } from '../../constants/common';
import { flatsViews } from '../../constants/flatsViews';
import { housesViews } from '../../constants/housesViews';
import { modes } from '../../components/ui/MainHeader/components/Search';
import {
  SET_CURRENT_COMPANY,
  SET_ENTRANCES_IN_VIEW,
  SET_SEARCH_FIELD_VALUE,
  RESET_SEARCH_FIELD_VALUE,
  SET_CURRENT_HOUSE,
  SET_CURRENT_FLAT,
  SET_FLATS_GRID_DATA,
  SET_FLATS_TABLE_DATA,
  SET_FLATS_VIEW,
  SET_HOUSES_VIEW,
  SET_ACTIVE_ENTRANCE_NAME,
  SET_FLATS_TABLE_PAGE,
  SET_HOUSES_TABLE_PAGE,
  SET_DOC_FORM_DATA,
  SET_METER_MODAL_DATA,
  SET_FLATS_GRID_PREVIEW_DATA,
  SET_TEMPLATE_MODAL_DATA,
  SET_CURRENT_HOUSES_REGISTER,
  SET_SELECTED_FLATS,
  SET_AVAILABLE_HOUSE,
  SET_AVAILABLE_FLAT,
  SET_CHESS_VIEW_COLOR_MODE,
  SET_MONITORING_STAGE,
  SET_DATE_EXCESS,
  SET_REQUEST_VALUES_ATTRIBUTES,
  OPEN_MODAL_TRANSPORTS_TENANT,
  CLOSE_MODAL_TRANSPORTS_TENANT,
  SET_VISIBLE_TRANSPORT_FORM,
} from '../actions/actionsTypes';
import { importsPageReducer } from '../../pages/ImportsPage';
import { chessViewMode } from '../../constants/chessViewMode';
import { requestFlatPeriod } from '../../constants/requestFlat';

const initialState = {
  currentCompany: null,
  entrancesInView: [],
  searchFieldValue: {
    [modes.houses]: '',
    [modes.tenants]: '',
    [modes.accounts]: '',
    [modes.flats]: '',
  },
  currentHouse: null,
  currentHousesRegister: null,
  templateModalData: null,
  currentFlat: null,
  flatsGridData: [],
  flatsTableData: undefined,
  flatsView: flatsViews.table,
  housesView: housesViews.list,
  activeEntranceName: initActiveEntranceName,
  flatsTablePage: 0,
  housesTablePage: 0,
  docFormData: null,
  meterModalData: null,
  flatsGridPreview: {
    data: [],
    file: null,
    houseId: null,
  },
  selectedFlats: [],
  selectedFlatsData: [],
  houseAvailable: null,
  flatAvailable: null,
  chessViewColorMode: chessViewMode.stages,
  monitoringStage: 3, // Приемка
  dateExcess: null,
  valuesRequestAttributes: [],
  visibleTransportTenant: null,
  visibleTransportForm: null,
};

const newHousingStockReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CURRENT_COMPANY:
      return {
        ...state,
        currentCompany: payload,
      };
    case SET_SELECTED_FLATS:
      return {
        ...state,
        selectedFlats: payload.map((item) => item.addressId),
        selectedFlatsData: payload,
      };
    case SET_CHESS_VIEW_COLOR_MODE:
      return {
        ...state,
        chessViewColorMode: payload,
      };
    case SET_MONITORING_STAGE:
      return {
        ...state,
        monitoringStage: payload,
      };
    case SET_ENTRANCES_IN_VIEW:
      return {
        ...state,
        entrancesInView: payload,
      };
    case SET_SEARCH_FIELD_VALUE:
      return {
        ...state,
        searchFieldValue: { ...state.searchFieldValue, ...payload },
      };
    case SET_AVAILABLE_HOUSE:
      return {
        ...state,
        houseAvailable: payload,
      };
    case SET_AVAILABLE_FLAT:
      return {
        ...state,
        flatAvailable: payload,
      };
    case SET_DATE_EXCESS:
      return {
        ...state,
        dateExcess: payload,
      };
    case RESET_SEARCH_FIELD_VALUE:
      return {
        ...state,
        searchFieldValue: {
          [modes.houses]: '',
          [modes.tenants]: '',
          [modes.accounts]: '',
          [modes.flats]: '',
        },
      };
    case SET_CURRENT_HOUSE:
      return {
        ...state,
        currentHouse: payload,
      };
    case SET_CURRENT_FLAT:
      return {
        ...state,
        currentFlat: payload,
      };
    case SET_FLATS_GRID_DATA:
      return {
        ...state,
        flatsGridData: payload,
      };
    case SET_FLATS_TABLE_DATA:
      return {
        ...state,
        flatsTableData: payload,
      };
    case SET_VISIBLE_TRANSPORT_FORM:
      return {
        ...state,
        visibleTransportForm: payload,
      };
    case SET_FLATS_VIEW:
      return {
        ...state,
        flatsView: payload,
      };
    case SET_HOUSES_VIEW:
      return {
        ...state,
        housesView: payload,
      };
    case SET_ACTIVE_ENTRANCE_NAME:
      return {
        ...state,
        activeEntranceName: payload,
      };
    case SET_FLATS_TABLE_PAGE:
      return {
        ...state,
        flatsTablePage: payload,
      };
    case SET_HOUSES_TABLE_PAGE:
      return {
        ...state,
        housesTablePage: payload,
      };
    case SET_DOC_FORM_DATA:
      return {
        ...state,
        docFormData: payload,
      };
    case SET_METER_MODAL_DATA:
      return {
        ...state,
        meterModalData: payload,
      };
    case SET_FLATS_GRID_PREVIEW_DATA:
      return {
        ...state,
        flatsGridPreview: payload,
      };
    case SET_TEMPLATE_MODAL_DATA:
      return {
        ...state,
        templateModalData: payload,
      };
    case SET_CURRENT_HOUSES_REGISTER:
      return {
        ...state,
        currentHousesRegister: payload,
      };
    case SET_REQUEST_VALUES_ATTRIBUTES:
      return {
        ...state,
        valuesRequestAttributes: payload,
      };
    case CLOSE_MODAL_TRANSPORTS_TENANT:
      return {
        ...state,
        visibleTransportTenant: null,
      };
    case OPEN_MODAL_TRANSPORTS_TENANT:
      return {
        ...state,
        visibleTransportTenant: payload,
      };
    default:
      return {
        ...state,
        importsPageState: importsPageReducer(state.importsPageState, {
          type,
          payload,
        }),
      };
  }
};

export default newHousingStockReducer;
